export interface PermissionConfig {
    enabled: boolean;
}
export const DEFAULT_PERMISSION_CONFIG: PermissionConfig = {
    enabled: false,
}
